import axios from 'axios';

export async function getIpInfo() {
  const response = await axios.get('https://api.ipstack.com/check?access_key=44fac15d85a0830e0a9bdebd0bef5728', {
    timeout: 2000
  });
  return response.data;
}
